import { render, staticRenderFns } from "./ExternalProjectDetails.vue?vue&type=template&id=59db8c98&scoped=true"
import script from "./ExternalProjectDetails.vue?vue&type=script&lang=js"
export * from "./ExternalProjectDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db8c98",
  null
  
)

export default component.exports